import React from 'react';
import { connect } from 'react-redux';
// LevelEditor imports
import TopBar from './TopBar';
import BottomBar from './BottomBar';
import SideBar from '../SideBar';
import DropZone from './DropZone';
// Game(kit) imports
import gameKit from '../../../GameKit';

import { SideBarItems } from '../../shared';

class LevelEditor extends React.Component {
    componentDidUpdate() {
        gameKit.game.updateRenderSize();
    }

    render() {
        const { active, sideBar } = this.props;

        return (
            <div className="full-height" style={active ? {} : { display: 'none' }}>
                <div className="canvas-wrapper vertical-align">
                    <TopBar />
                    {sideBar.activeItem !== SideBarItems.NONE && <SideBar />}
                    <BottomBar />
                    <DropZone>
                        <div className="canvas-wrapper-inner" id="editor-canvas-wrapper" />
                    </DropZone>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    levelEditor: state.levelEditor,
    sideBar: state.sideBar
});

export default connect(mapStateToProps)(LevelEditor);
